module.exports = __webpack_public_path__ + "img/popup-game-sucai.e68c44d6.png";